import WorkOrderList from './WorkOrderList';

export default WorkOrderList;
export * from './WorkOrderList';
